import DepartamentoService from "@/api/services/personal/nomencladores/DepartamentoService"
import Vue from "vue"

const state = () => ({
    departamentos: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "nombre",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    DEPARTAMENTOS: state => {
        return state.departamentos
    },
    DEPARTAMENTOS_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_DEPARTAMENTOS: (state, payload) => {
        state.departamentos = payload
    },

    SET_DEPARTAMENTOS_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_DEPARTAMENTO: (state, payload) => {
        payload.secciones = []
        state.departamentos.push(payload)
    },

    UPDATE_DEPARTAMENTO: (state, payload) => {
        state.departamentos = state.departamentos.map(el => (el.id === payload.id ? payload : el))
    },

    DELETE_DEPARTAMENTO: (state, payload) => {
        state.departamentos = state.departamentos.filter(el => el.id !== payload.id)
    }
}

const actions = {
    LOAD_DEPARTAMENTOS: async ({ commit, state }, { filter, departamentoEstado }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }
            let { data, status, headers } = await DepartamentoService.get({ filter, departamentoEstado, ...pagination })
            if (status === 200) {
                commit("SET_DEPARTAMENTOS", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los departamentos, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_DEPARTAMENTOS: async ({ commit }) => {
        try {
            let { data, status } = await DepartamentoService.getAll()
            if (status === 200) {
                commit("SET_DEPARTAMENTOS", data)
                return data
            }
        } catch (error) {
            if (error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido realizar la acción"
                })
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_ALL_RECORDS_DEPARTAMENTOS: async ({ commit }) => {
        try {
            let { data, status } = await DepartamentoService.getAllRecords()
            if (status === 200) {
                commit("SET_DEPARTAMENTOS", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los departamentos, inténtelo nuevamente"
            })
        }
    },

    LOAD_HISTORY_DEPARTAMENTO: async ({ commit }, payload) => {
        try {
            let { data, status } = await DepartamentoService.getHistory(payload)
            if (status === 200) {
                commit("UPDATE_DEPARTAMENTO", data)
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar el historial del departamento, inténtelo nuevamente"
            })
        }
    },

    ADD_DEPARTAMENTO: async ({ commit }, payload) => {
        try {
            let { data, status } = await DepartamentoService.post(payload)
            if (status === 201) {
                commit("ADD_DEPARTAMENTO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "El departamento ha sido agregado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar el departamento, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_DEPARTAMENTO: async ({ commit }, payload) => {
        try {
            let { data, status } = await DepartamentoService.put(payload)
            if (status === 200) {
                commit("UPDATE_DEPARTAMENTO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "El departamento ha sido modificado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar el departamento, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    DELETE_DEPARTAMENTO: async ({ commit }, payload) => {
        try {
            let { status, data } = await DepartamentoService.delete(payload)
            if (status === 204) {
                commit("DELETE_DEPARTAMENTO", payload)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Eliminando",
                    text: "El departamento ha sido eliminado satisfactoriamente"
                })
            }
            if (status === 200) {
                commit("UPDATE_DEPARTAMENTO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Deshabilitando",
                    text: "El departamento ha sido deshabilitado satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido eliminar/deshabilitar el departamento, inténtelo nuevamente"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
